export default function convertMonthYearDayToDateString(inputString: string) {
  // Split the input string into month, year, and day parts
  const [month, year, day] = inputString.split('-')

  // Use the Date constructor to create a new Date object for the given month, year, and day
  const dateObj = new Date(`${month} ${day}, ${year}`)

  // Get the year, month, and day components of the date object as strings
  const yearString = dateObj.getFullYear().toString()
  const monthString = (dateObj.getMonth() + 1).toString().padStart(2, '0')
  const dayString = dateObj.getDate().toString().padStart(2, '0')

  // Concatenate the year, month, and day strings into the desired format
  const outputString = `${yearString}-${monthString}-${dayString}`

  // Return the output string
  return outputString
}